import './dangerGigantBtn.css';

const DangerGigantBtn = ({onClick, label, sublabel}) => {
    return (
        <div className="danger-gigant-btn">
            <button id="dangerBtn" className="danger-btn animate" aria-label="Botón peligroso — no presionar"
                    data-testid="danger-button" onClick={onClick}>
                <span className="text">
                    <span className="mini">NO PULSAR</span>
                    <span className="big">PULSAR</span>
                </span>
            </button>

            <div className="danger-label">{label ?? "Peligro inminente"}</div>
            <div className="danger-sub">{sublabel ?? "parece inestable — procede con cautela"}</div>
        </div>
    );
}

export default DangerGigantBtn;
